import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import ApiError from '../../../../components/Errors/ApiError';
import { useTopCertifications } from '../../myTeamQueries';
import { Table } from 'foundations-components/transitional/components/Table';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { NavMarker } from 'react-rhumb';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CertificationLink from '../common/CertificationLink';
import { getPaginatedPosition } from '../../utils/paginationUtils';
import EmptyOverviewCard from '../common/EmptyOverviewCard';
import { usePaginatedTable } from '../../hooks/usePaginatedTable';
import { MY_TEAM_OVERVIEW_PAGE_SIZE } from '../../../pagination';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TopCertifications = () => {
  const {
    topCertifications,
    topCertificationsLoading,
    topCertificationsError
  } = useTopCertifications();
  const {
    startIndex,
    paginatedData: certificationsToDisplay,
    pageCount,
    pageNumber,
    handlePageChange
  } = usePaginatedTable(topCertifications, MY_TEAM_OVERVIEW_PAGE_SIZE);
  if (topCertificationsLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      layout: "centered",
      minHeight: "350px",
      size: "medium"
    });
  }
  if (topCertificationsError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "TOP_CERTIFICATIONS_API_ERROR",
      children: /*#__PURE__*/_jsx(ApiError, {
        error: {
          status: 500
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "TOP_CERTIFICATIONS_LOADED",
    children: certificationsToDisplay.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        condensed: true,
        "data-test-id": "top-certifications-table",
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.certifications.topCertifications.table.certification"
              })
            }), /*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.certifications.topCertifications.table.active"
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: certificationsToDisplay.map((cert, index) => /*#__PURE__*/_jsxs("tr", {
            "data-test-id": "top-certification-row",
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(CertificationLink, {
                certificationIconUrl: cert.certificationIconUrl,
                certificationId: cert.certificationId,
                certificationName: cert.certificationName,
                position: getPaginatedPosition(startIndex, index)
              })
            }), /*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx(FormattedNumber, {
                value: cert.certificationTotals.active
              })
            })]
          }, `${cert.certificationId}-${index}`))
        })]
      }), /*#__PURE__*/_jsx(Paginator, {
        onPageChange: handlePageChange,
        page: pageNumber,
        pageCount: pageCount,
        showButtonLabels: false
      })]
    }) : /*#__PURE__*/_jsxs(EmptyOverviewCard, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.noCertifications"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.certifications.findContent"
      })]
    })
  });
};
export default TopCertifications;